import { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useFeatureFlags } from '../context/FeatureFlagsContext';
import { astraStatus, previewToken } from '../services/astraLite';

// Whether a public page's "Ask Astra" box may show (#3262 college pages, #3272
// News stories): only where the open chat answers this visitor, as on the
// landing page. A guest, or an account dogfooding it (the preview token or the
// astra_lite allowlist); a signed-in student has Astra in the app. The route's
// own status must say the chat is open: a closed route or a spent budget hides
// the box, never an error.
//
// `enabled` false skips the status read (a page with nothing to ask about).
// Returns [on, close]; `close()` hides the box (the chat said it is unavailable).
export default function useAskAstraOn(enabled = true) {
    const { currentUser } = useAuth();
    // Only a signed-in account reads its flags (the allowlist); a guest's
    // answer is the route's own status below, so a guest makes no flag call.
    const { flags, forEmail } = useFeatureFlags({ mine: Boolean(currentUser), public: false }) || {};
    const [chatOpen, setChatOpen] = useState(true);
    const internalChat = Boolean(currentUser) && (Boolean(previewToken())
        || (Boolean(flags?.astra_lite) && forEmail === currentUser.email));
    useEffect(() => {
        if (!enabled) return undefined;
        let alive = true;
        astraStatus().then((s) => { if (alive && (!s || !s.success || s.chat !== true)) setChatOpen(false); })
            .catch(() => { if (alive) setChatOpen(false); });
        return () => { alive = false; };
    }, [enabled]);
    const on = Boolean(enabled) && chatOpen && (!currentUser || internalChat);
    return [on, () => setChatOpen(false)];
}
